import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { Container, Grid, Typography } from '@material-ui/core'
import useLazyState from '../../hooks/useLazyState'
import Link from 'next/link'
import FacebookIcon from '@material-ui/icons/Facebook'
import TwitterIcon from '@material-ui/icons/Twitter'
import InstagramIcon from '@material-ui/icons/Instagram'
import YouTubeIcon from '@material-ui/icons/YouTube'
import AppleIcon from '@material-ui/icons/Apple'
import PlayArrowIcon from '@material-ui/icons/PlayArrow'
import AmericanCard from '../../assets/images/payment-americanExpress.png'
import PaymentDiscover from '../../assets/images/payment-discover.png'
import MasterCard from '../../assets/images/payment-mastercard.png'
import Visa from '../../assets/images/payment-visa.png'
import Image from 'next/image'
const styles = () => ({
  centralFooter: c => ({
    background: c.backgroundColor,
  }),
  linkColor: c => ({
    color: c.color,
    '&:hover': {
      color: c.hoverColor,
    },
  }),
  headingColor: c => ({
    color: c.color,
  }),
})
const useStyles = makeStyles(styles)
export default function FooterCentral({ config, storeSlug }) {
  const [state] = useLazyState(config)
  let themeColor =
    config && config.hasOwnProperty('web_theme_color')
      ? config.web_theme_color + ' !important'
      : '#1e3041 !important'
 
  let fontColor =
    config && config.hasOwnProperty('web_theme_font_color')
      ? config.web_theme_font_color
      : '#FFFFFF'
  const mystyle = {
    backgroundColor: storeSlug ? `${themeColor}` : '',
    color: storeSlug ? `${fontColor}` + ' !important' : '#FFFFFF !important',

    hoverColor: '#9c9c9c !important',
  }

  const classes = useStyles(mystyle)
  return (
    <>
      {state.hasOwnProperty('loading') && !state.loading && config && (
        <div className={'footer-container central-footer ' + classes.centralFooter}>
          <Container>
            <Grid container>
              <Grid item lg={2} sm={4} md={2} xs={6}>
                <div className="link-blk">
                  <Typography color="secondary" variant="h4" className={classes.headingColor}>
                    BottleZoo
                  </Typography>
                  <ul className="footer-links">
                    <li>
                      <Link href="/termsandconditions" className={classes.linkColor}>
                        Terms And Conditions
                      </Link>
                    </li>
                    <li>
                      <Link href="/privacypolicy" className={classes.linkColor}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link
                        href={storeSlug ? '/store/' + storeSlug + '/contactus' : '/contactus'}
                        className={classes.linkColor}
                      >
                        Contact Us
                      </Link>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item lg={2} sm={4} md={2} xs={6}>
                <div className="link-blk">
                  {config && (
                    config.bizfburl
                    || config.biztwitterurl
                    || config.bizinstaurl
                    || config.bizyoutubeurl) ? (
                  <Typography color="secondary" variant="h4" className={classes.headingColor}>
                    Follow Us
                  </Typography>
                  ) : (
                    ''
                  )}
                  <ul className="social-links">
                  {config && config.bizfburl ? (
                      <li className="facebook-icon">
                        <Link
                          target="_blank"
                          href={config.bizfburl}
                          className={classes.linkColor}
                        >
                            <FacebookIcon />
                        </Link>
                      </li>
                    ) : (
                      ''
                    )}
                    {config && config.biztwitterurl ? (
                      <li className="twiter-icon" >
                        <Link
                          target="_blank"
                          href={config.biztwitterurl}
                          className={classes.linkColor}>
                            <TwitterIcon />
                        </Link>
                      </li>
                    ) : (
                      ''
                    )}
                    {config && config.bizinstaurl ? (
                      <li className="insta-icon">
                        <Link
                          target="_blank"
                          href={config.bizinstaurl}
                          className={classes.linkColor}>
                            <InstagramIcon />
                        </Link>
                      </li>
                    ) : (
                      ''
                    )}
                    {config && config.bizyoutubeurl ? (
                      <li className="youtube-icon">
                        <Link
                          target='_blank'
                          href={config.bizyoutubeurl}
                          className={classes.linkColor}>
                            <YouTubeIcon />
                        </Link>
                      </li>
                    ) : (
                      ''
                    )}
                  </ul>
                </div>
              </Grid>
              <Grid item lg={2} sm={4} md={2} xs={6}>
                <div className="link-blk">
                  <Typography color="secondary" variant="h4" className={classes.headingColor}>
                    Support
                  </Typography>
                  <ul className="footer-links">
                    <li>
                      <Link href="/" className={classes.linkColor}>
                        Email Support
                      </Link>
                    </li>
                    <li>
                      <Link href="/faq" className={classes.linkColor}>
                        FAQs
                      </Link>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item lg={3} sm={4} md={3} xs={6}>
                <div className="link-blk">
                  <Typography color="secondary" variant="h4" className={classes.headingColor}>
                    Download Our App
                  </Typography>
                  <ul className="social-links">
                    <li className="facebook-icon">
                      <Link
                        href={'https://apps.apple.com/us/app/bottlezoo/id1585803701'}
                        className={classes.linkColor}
                      >
                          <AppleIcon />
                      </Link>
                    </li>
                    <li className="twiter-icon">
                      <Link
                        href={'https://play.google.com/store/apps/details?id=com.app.bottlezoo'}
                        className={classes.linkColor}
                      >
                          <PlayArrowIcon />
                      </Link>
                    </li>
                  </ul>
                </div>
              </Grid>
              <Grid item lg={3} sm={4} md={3} xs={6}>
                <div className="link-blk">
                  <Typography color="secondary" variant="h4" className={classes.headingColor}>
                    We Accept
                  </Typography>
                  <ul className="paymentlist">
                    <li>
                      <Link href="/" className={classes.linkColor}>
                          <Image
                            src={AmericanCard}
                            width="72"
                            height="46"
                            alt="American Express"
                          />
                      </Link>
                    </li>
                    <li>
                      <Link href="/" className={classes.linkColor}>
                          <Image
                            src={PaymentDiscover}
                            width="72"
                            height="46"
                            alt="Payment Discover"
                          />
                      </Link>
                    </li>
                    <li>
                      <Link href="/" className={classes.linkColor}>
                          <Image src={MasterCard} width="72" height="46" alt="Mastercard"/>
                      </Link>
                    </li>
                    <li>
                      <Link href="/" className={classes.linkColor}>
                          <Image src={Visa} width="72" height="46" alt="Visa"/>
                      </Link>
                    </li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </Container>
        </div>
      )}
    </>
  )
}